export enum NAV_HEIGHTS {
  DESKTOP = "100px",
  TABLET = "80px",
}
